module.exports = __webpack_public_path__ + "img/banner4.3d24d6ab.png";